module.exports = __webpack_public_path__ + "img/construction-robot-working.9e6eb756.png";